import { CloseOutlined } from '@mui/icons-material';
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import React from 'react';

import { LogoMark2cIconC } from '@/assets';
import { muiPalette } from '@/shared/general-theme';

import { HeaderElementsType } from '../../duck';

interface MobileHeaderProps {
  mobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
  headerElements: HeaderElementsType[];
  handleChangePage: (_e: React.SyntheticEvent, newValue: number) => void;
  currentPage: string;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  mobileMenuOpen,
  toggleMobileMenu,
  headerElements,
  handleChangePage,
  currentPage,
}) => {
  return (
    <Drawer
      anchor='right'
      open={mobileMenuOpen}
      onClose={toggleMobileMenu}
      slotProps={{
        paper: {
          sx: {
            width: '90%',
            maxWidth: '30rem',
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
    >
      <Box sx={{ p: '0.5rem 1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <LogoMark2cIconC
          style={{
            height: '1.5rem',
          }}
        />
        <Typography
          variant='body1'
          component='div'
          sx={{
            ml: '0.75rem',
            fontWeight: 800,
            letterSpacing: '-0.02em',
            color: muiPalette.primary.main,
          }}
        >
          PLATYPUS<span style={{ color: muiPalette.tertiary.main }}>.</span>
        </Typography>
        <IconButton onClick={toggleMobileMenu}>
          <CloseOutlined />
        </IconButton>
      </Box>

      <Divider />

      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        <List sx={{ px: '1rem' }}>
          {headerElements.map((element) => {
              const Icon = element.icon || '';
              return (
                <ListItem key={element.title} disablePadding sx={{ mb: '0.5rem' }}>
                  <ListItemButton
                    onClick={(e) => handleChangePage(e, headerElements.findIndex(el => el.title === element.title))}
                    selected={currentPage === element.title}
                    sx={{
                      borderRadius: '1.5rem',
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(138, 178, 196, 0.15)',

                        '& .MuiListItemIcon-root': {
                          color: muiPalette.primary.dark,
                        },
                        '& .MuiListItemText-primary': {
                          color: muiPalette.primary.dark,
                        },
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{ color: muiPalette.text.secondary, minWidth: 40 }}
                    >
                      {Icon && <Icon />}
                    </ListItemIcon>
                    <ListItemText
                      primary={element.title}
                      slotProps={{
                        primary: {
                          color: muiPalette.text.secondary,
                          fontWeight: 600,
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            },
          )}
        </List>
      </Box>
    </Drawer>
  );
};

export default MobileHeader;